'use client';

import { useRouter } from 'next/navigation';

import PointLoungeListItem from '@/app/(football)/[team]/_components/common/PointLoungeListItem';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import type { PointUseType } from '@/store/server/common/football/football.dto';
import { momentTimezone } from '@/utils/time';

interface UsePointLoungeListItemProps {
  methodIdx: number;
  type: PointUseType;
  title: string;
  image: string;
  point: number;
  remainAmount: number;
  startDttm: number;
  endDttm: number;
}

export default function UsePointLoungeListItem({
  methodIdx,
  type,
  title,
  image,
  point,
  remainAmount,
  startDttm,
  endDttm,
}: UsePointLoungeListItemProps) {
  const router = useRouter();
  const { teamSlug } = useTeamConfig();

  const handleClick = () => {
    router.push(`/${teamSlug}/point-lounge/use/${methodIdx}`);
  };

  const formattedStartDate = momentTimezone(startDttm).format('YY.MM.DD');
  const formattedEndDate = momentTimezone(endDttm).format('YY.MM.DD');
  const dateRange = `${formattedStartDate} ~ ${formattedEndDate}`;

  return (
    <PointLoungeListItem
      type={type}
      title={title}
      image={image}
      point={point}
      remainAmount={remainAmount}
      dateRange={dateRange}
      onClick={handleClick}
    />
  );
}
